import { AudioPlayButton, MediaMetadata } from "../../radioWidgets/floatingPlayer/audioPlayButton";
import { CalcalistPodcastPopupPlayer } from "./calcalistPodcastPopupPlayer";

interface CalcalistPodcastPlayerProps {
    audioUrl: string
    title: string
    durationSeconds: number
    podcastImage: string
    openPopupPlayer: () => void
    browserDisplayMediaMetaData?: MediaMetadata
}

export function CalcalistPodcastPlayer(props: CalcalistPodcastPlayerProps) {
    const { audioUrl, title, durationSeconds, podcastImage, browserDisplayMediaMetaData } = props;
    
    return (
        <AudioPlayButton
            audioUrl={audioUrl}
            durationSeconds={durationSeconds}
            renderer={() => null}
            floatingPlayerRenderer={(props) => (<CalcalistPodcastPopupPlayer {...props} audioUrl={audioUrl} title={title} podcastImage={podcastImage}/>)}
        />
    )
}

CalcalistPodcastPlayer.siteScriptName = 'CalcalistPodcastPlayer'